import styled, { css } from 'styled-components'

import { isAndroid, isCordova, isDesktop } from '@/helpers'
import { E_ZIndexes } from '@/helpers/consts'
import { E_Colors } from '@/helpers/colors'


export const SC_BottomBarWrapper = styled.div`
  height: 82px;
  padding: 6px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 520px;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0px -0.5px 0px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(27px);
  z-index: ${E_ZIndexes.Level4};

  ${(isCordova || isAndroid || isDesktop) && css`
    padding-bottom: 0;
    height: 60px;
  `}
`

export const SC_AppSectionBtn = styled.div<{ $hasUnread?: boolean }>`
  width: 37px;
  height: 37px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;

  &::after {
    content: '';
    display: ${(p) => (p.$hasUnread ? 'block' : 'none')};
    width: 8px;
    height: 8px;
    background-color: ${E_Colors.EraRed};
    border-radius: 50%;
    position: absolute;
    top: -8px;
    right: 1px;
  }

  img {
    width: 70%;
  }

  span {
    font-size: 10px;
  }
`
